module.exports = __webpack_public_path__ + "static/18-8261ffbd8f64e9d882b5780c48c90209.jpg";